













































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalRegraDeCalculoIncluirLocaisExecucao from './ModalRegraDeCalculoIncluirLocaisExecucao.vue'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    ModalRegraDeCalculoIncluirLocaisExecucao
  },
})
export default class LocaisExecucaoDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadOperadoras: boolean = false
  get loadingOperadoras() { return this.loadOperadoras }
  set loadingOperadoras(value: boolean) { this.loadOperadoras = value }

  get header() {
    return [
      { text: 'Nome local de execução', value: 'localExecucaoNome', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsLocalExecucao() {
    return this.getRegrasDeCalculoStore.localExecucaoRegraCalculo || []
  }
  get paginacaoOperadoras() { return this.getRegrasDeCalculoStore.paginacaoOperadoras }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarRegraDeCalculoOperadora: string = ''
  get loadingDeletarRegraDeCalculoOperadora() { return this.loadDeletarRegraDeCalculoOperadora }
  set loadingDeletarRegraDeCalculoOperadora(value: string) { this.loadDeletarRegraDeCalculoOperadora = value }

  get showModalAddRegraCalculoOperadora() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoOperadora }
  set showModalAddRegraCalculoOperadora(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoOperadora', value }) }

  async removeRegraCalculoOperadora(regraId: string) {
    this.loadingDeletarRegraDeCalculoOperadora = regraId
    const request = await this.getRegrasDeCalculoStore.removeLocalExecucao(regraId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarRegraDeCalculoOperadora = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Operadora excluída com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarRegraDeCalculoOperadora = ''
  }

  @Watch('showModalAddRegraCalculoOperadora')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (value) {
      this.getRegrasDeCalculoStore.setPorOperadoraOuPorClassificacao('PorOperadora')
    }

    if (!value) {
      this.getRegrasDeCalculoStore.clearPessoaOperadoraAIncluir()
      this.getRegrasDeCalculoStore.clearClassificacaoOperadoraAIncluir()
      this.getRegrasDeCalculoStore.setPorOperadoraOuPorClassificacao('PorOperadora')
    }
  }
}
